import { render, staticRenderFns } from "./PlayerLimits.vue?vue&type=template&id=3945ab38&scoped=true&"
import script from "./PlayerLimits.vue?vue&type=script&lang=js&"
export * from "./PlayerLimits.vue?vue&type=script&lang=js&"
import style0 from "./PlayerLimits.vue?vue&type=style&index=0&id=3945ab38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3945ab38",
  null
  
)

export default component.exports